import {FC, useEffect, useState} from 'react'
import Content from "../main/Content";
import CheckBox from "../common/Checkbox/Checkbox";
import CheckBoxButton from "../common/Checkbox/CheckboxButton";
import Offers from "../Campaign";
import Calendar from "../common/Calendar";
import {getCalendar} from "../../wordpress/operations/get-calendar";
import {bookingCalendar, windowRepairImage} from "../../constants/global";
import ChipMarker from "./ChipMarker";
import {postFile} from "../../wordpress/operations/post-file";
import {storeBooking} from "../../lib/booking";
import {getInsurance} from "../../wordpress/operations/get-insurance";
import {InsuranceVTR} from "../../types";
import InsuranceInfo from "./InsuranceInfo";
import ChipCount from "./ChipCount";
import NavNextPrev from "../common/NavNextPrev/NavNextPrev";
import {resetDateCarousel} from "../../lib/date-caroussel";

interface Props {
    booking: Booking
    pageContent: ContentPage,
    setBooking: Function,
    insurance: any,
    content: Content
}

const Window: FC<Props> = ({pageContent, booking, setBooking, insurance, content}) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const [calendarVisible, setCalendarVisible] = useState(false);
    const [month, setMonth] = useState<any>(null);
    const [vtrInsurance, setVtrInsurance] = useState<InsuranceVTR | null>(null);

    if (!vtrInsurance) {
        getInsurance(booking.car.reg).then((val) => {
            setVtrInsurance(val)
            booking.car.insurance = val
            storeBooking(booking, setBooking)
        })
    }

    const getMonth = (date: string = '') => {
        getCalendar(booking, date, 'plain').then((val) => {
            bookingCalendar.slots = []
            setMonth(val)
        })
    }
    if (!month)
        getMonth() // Current month

    const setDate = (date: string = '') => {
        setDamageDate(date)
        setCalendarVisible(false)
        booking.window.form.damage_date = date
        storeBooking(booking, setBooking)
    }

    // Form
    const [damageDate, setDamageDate] = useState(booking.window.form.damage_date)
    const [damagePlace, setDamagePlace] = useState(booking.window.form.damage_place)
    const [insuranceCompany, setInsuranceCompany] = useState(booking.window.form.insurance_company)
    const [comments, setComments] = useState(booking.window.form.order_comments)
    const [windowDamageType, setWindowDamageType] = useState(booking.window.form.window_damage_type)
    const [image, setImage] = useState(windowRepairImage.image)
    const [uploadStatus, setUploadStatus] = useState('')

    const updateField = (e: any) => {
        switch (e.target.name) {
            case 'damage_place':
                booking.window.form.damage_place = e.target.value
                setDamagePlace(e.target.value)
                break;
            case 'order_comments':
                booking.window.form.order_comments = e.target.value
                setComments(e.target.value)
                break;
            case 'insurance_company':
                booking.window.form.insurance_company = e.target.value
                setInsuranceCompany(e.target.value)
                break;
        }
        storeBooking(booking, setBooking)
    }

    const onFileChange = (e: any) => {
        let files = e.target.files;
        let fileReader = new FileReader();
        fileReader.readAsDataURL(files[0]);
        setUploadStatus('')

        fileReader.onload = (event) => {
            postFile(booking, event.target.result).then((response) => {
                if (response.error) {
                    setUploadStatus(response.data)
                    windowRepairImage.image = ''
                    setImage('')
                } else {
                    windowRepairImage.image = response.data
                    setImage(response.data)
                }
            })
        }
    }

    const handleCheckBox = (box: string, value: any) => {
        console.log('box', box)
        if(windowDamageType === 'crack' && box === 'window_damage_type_crack') {
            box = '';
        }
        if(windowDamageType === 'chip' && box === 'window_damage_type_chip') {
            box = '';
        }

        booking.submission.slug = '';
        booking.submission.name = '';
        booking.submission.type = [];
        booking.workshop = null
        booking.group = null
        booking.date = ''
        booking.window.date = ''
        booking.resource = null
        booking.calendar_carousel = resetDateCarousel()

        switch (box) {
            case 'window_damage_type_crack':
                setWindowDamageType('crack')
                booking.window.form.chip_counter = 0
                booking.window.form.window_damage_type = 'crack'
                break;
            case 'window_damage_type_chip':
                setWindowDamageType('chip')
                booking.window.form.window_damage_type = 'chip'
                break;
            case '':
                setWindowDamageType('')
                booking.window.form.window_damage_type = ''
                break;
        }
        storeBooking(booking, setBooking)
    }

    return (
        <div className="input-outer reg-container">
            <div className="row mobile-reverse">
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-xxs-12">
                    <Offers booking={booking} setBooking={setBooking}/>
                </div>
                <div className={"main-bg pb-4 col-lg-8 col-md-8 col-sm-12 col-xs-12 col-xxs-12 page-booking window " + windowDamageType}>
                    <Content booking={booking} content={pageContent}/>
                    <form name="window-repair" method="post" className="" action="" encType="multipart/form-data">
                        <div className="row bg-white r-0 pt-4">
                            <div className="input-outer col-lg-7 col-md-12 col-sm-12 col-xs-12 col-xxs-12">
                                <label className={"text-lg"}>Laga stenskott</label>
                                <p className={"mb-0"}>Mindre än en femkrona. Upp till tre stenskott kan lagas vid ett
                                    tillfälle. Är det
                                    fler behöver hela vindrutan bytas.</p>
                            </div>
                            <div className="input-outer col-lg-5 col-md-12 col-sm-12 col-xs-12 col-xxs-12">
                                <div className={"flex"}>
                                    <CheckBoxButton radio={true} title={'Välj'} active={windowDamageType === 'chip'}
                                                    type={'window_damage_type_chip'} handle={handleCheckBox}/>
                                </div>
                            </div>
                        </div>
                        { booking.window.form.window_damage_type === 'chip' && (
                            <div className="row bg-white r-0">
                                <div className="input-outer col-lg-7 col-md-12 col-sm-12 col-xs-12 col-xxs-12">
                                    <label className={"required"}>Antal stenskott</label>
                                </div>
                                <div className="input-outer col-lg-5 col-md-12 col-sm-12 col-xs-12 col-xxs-12">
                                    <ChipCount booking={booking} setBooking={setBooking}/>
                                </div>
                            </div>
                        )}

                        {windowDamageType === 'chip' && (
                            <div className="row bg-white r-0">
                                <div className="input-outer col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xxs-12">
                                    <NavNextPrev booking={booking} setBooking={setBooking} content={content}/>
                                </div>
                            </div>
                        )}

                        <div className="row bg-white r-0 pt-4 mt-4">
                            <div className="input-outer col-lg-7 col-md-12 col-sm-12 col-xs-12 col-xxs-12">
                                <label className={"text-lg"}>Byta vindruta</label>
                                <p className={"mb-0"}>Vid större skador, sprickor och vid fler en tre stenskott.
                                    Du lämnar in bilen under dagen och har möjlighet till lånebil under
                                    tiden.</p>
                            </div>
                            <div className="input-outer col-lg-5 col-md-12 col-sm-12 col-xs-12 col-xxs-12">
                                <div className={"flex"}>
                                    <CheckBoxButton radio={true} title={'Välj'}
                                                    active={windowDamageType === 'crack'}
                                                    type={'window_damage_type_crack'} handle={handleCheckBox}/>
                                </div>
                            </div>
                        </div>
                        {windowDamageType === 'crack' && (
                            <div className="row bg-white r-0">
                                <div className="input-outer col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xxs-12">
                                    <NavNextPrev booking={booking} setBooking={setBooking} content={content}/>
                                </div>
                            </div>
                        )}

                        <div className="row bg-white r-0 pt-4 mt-4">
                            {vtrInsurance && (
                                <InsuranceInfo vtrInsurance={vtrInsurance}/>
                            )}
                            <div className="input-outer col-lg-7 col-md-12 col-sm-12 col-xs-12 col-xxs-12">
                                <label>Övrig info</label>
                                <textarea id="order_comments" name="order_comments"
                                          placeholder="Här kan du lämna mer info om din skada. Ladda gärna upp en bild, annars klicka på nästa steg nedan."
                                          value={comments} onChange={updateField}/>
                            </div>
                            <div className="input-outer col-lg-5 col-md-12 col-sm-12 col-xs-12 col-xxs-12">
                                <label className="control-label normal" htmlFor="window_image">Ladda upp bild
                                    (valfritt)<br/><small>jpeg/png, max-storlek: 2MB</small></label>
                                <input id="window_image" accept="image/jpeg,image/png" type="file"
                                       name="window_image" onChange={onFileChange}/>
                                {image && (
                                    <img src={image} alt={'stenskottsbild'}/>
                                )}
                                <div className="btn btn-upload btn-center btn--gray"
                                     onClick={() => document.getElementById('window_image').click()}>Välj bild
                                </div>
                                <div className={'upload-feedback'}>{uploadStatus}</div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
};

export default Window
